module.exports = __webpack_public_path__ + "img/bauger_04.e987d6de.png";